// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"25b06bd4","300":"25b06bd4","427":"25b06bd4","616":"25b06bd4","741":"25b06bd4","761":"25b06bd4","829":"25b06bd4","897":"25b06bd4","933":"25b06bd4"}[chunkId] + ".chunk.css";
};